import { apiCall } from '../../context/api';

export const createAdmin = async (formData, setToken, baseURL) => {
  const data = await apiCall(baseURL, null, 'POST', '/core/onboarding/create-admin', formData);
  setToken(data.token);
};
